import { useQuery, UseQueryResult } from "@tanstack/react-query";
import { enum_api_uri } from "../utils/enum";
import axiosInstance from "./axiosInstance";

export interface ConsoleOrderDetailRequest {
    category: string;
    list_no: string;
}
export type DataListProps = {
    list_no: number;
    w_date: string;
    c_name: string;
    c_charge_name: string;
    c_dept_name: string;
    c_mobile: string;
    kind: string;
    pay_gbn: string;
    doc: string;
    sfast: string;
    item_type: string;
    s_start: string;
    start_telno: string;
    dept_name: string;
    charge_name: string;
    start_sido: string;
    start_gugun: string;
    start_dong: string;
    start_location: string;
    s_dest: string;
    dest_telno: string;
    dest_dept: string;
    dest_charge: string;
    dest_sido: string;
    dest_gugun: string;
    dest_dong: string;
    dest_location: string;
    reason_desc: string;
    kind_etc: string;
    dtime: string;
};

export type ResponseData = DataListProps;

export const useGetConsoleExpressOrderDetail = (data: ConsoleOrderDetailRequest | null): UseQueryResult<ResponseData, Error> => {
    return useQuery({
        queryKey: ["useGetConsoleExpressOrderDetail", data],
        queryFn: async () => {
            if (!data) throw new Error("Invalid request data");
            let url = enum_api_uri.get_console_order_info.replace(":category", data.category).replace(":serial_number", data.list_no);
            const response = await axiosInstance.get(url);
            return response.data.data;
        },
        enabled: !!data && !!data.list_no,
    });
};
